import { action } from 'easy-peasy';
import unionBy from 'lodash/unionBy';
import sortByName from '~/ui/pages/Reports/helpers/sortByName';
import { IActionSetClientOptionsByTeam } from '../types';

const setClientOptionsByTeam: IActionSetClientOptionsByTeam = action((state, payload) => {
  const { items, total, archived, includeDeleted } = payload;

  const newItems = unionBy([...items, ...state.clientOptionsByTeam.list], 'id').sort(sortByName);

  state.clientOptionsByTeam.list = includeDeleted
    ? newItems
    : newItems.filter(
        item =>
          (!state.clientOptionsByTeam.filters?.teamIds?.length ||
            item.teams.some(team =>
              state.clientOptionsByTeam.filters?.teamIds?.includes(team.id),
            )) &&
          !archived?.includes(item.id), // exclude archived clients
      );

  if (state.clientOptionsByTeam.isAllSelected && !state.clientOptionsByTeam.excluded.length) {
    state.clientOptionsByTeam.current = newItems;
  }

  if (typeof total === 'number') {
    state.clientOptionsByTeam.total = total;
  }
});

export default setClientOptionsByTeam;
